import {Action} from 'redux';
import {SEND_USER_MAIL} from './constants';
import {API} from '../../../utils/API';

export interface IJobsAction extends Action {
  payload?: any;
}

export interface IJobsSendMailParams {
  jobKey: string;
  text: string;
}

export const jobsSendMail = (params: IJobsSendMailParams) => ({
  type: SEND_USER_MAIL,
  payload: API.postJSON('/careers', params),
});
